import { WithLogoCellRenderer } from "./WithLogoCellRenderer"

type ProjectCellRendererData = {
  project_logo?: string
  project_name?: string
}

export class ProjectCellRenderer extends WithLogoCellRenderer<
  ProjectCellRendererData,
  { name: string; logo: string }
> {
  constructor() {
    super({
      textField: "name",
      logoField: "logo",
    })
  }
}
